// extracted by mini-css-extract-plugin
export default {"title":"NoSavedPlaces_title__hPyeD","description":"NoSavedPlaces_description__wVDkv","wrapper":"NoSavedPlaces_wrapper__66SYZ"};